import uaParser from '../../node_modules/.pnpm/ua-parser-js@1.0.40/node_modules/ua-parser-js/src/ua-parser.js';

const isTouchDevice = () => {
    return navigator && navigator.maxTouchPoints > 0;
};
var Platform;
(function (Platform) {
    Platform["iPad"] = "iPad";
    Platform["Mac"] = "Mac";
    Platform["Windows"] = "Windows";
    Platform["iPhone"] = "iPhone";
    Platform["Android"] = "Android";
    Platform["Linux"] = "Linux";
    Platform["Other"] = "Other";
})(Platform || (Platform = {}));
class PlatformAPI {
    static instance = new PlatformAPI();
    userAgentData = new uaParser().getResult();
    platform;
    constructor() {
        this.platform = this.calculatePlatform();
    }
    static getInstance() {
        return this.instance;
    }
    calculatePlatform() {
        switch (this.getOSName()) {
            case "iOS": {
                const deviceType = this.userAgentData?.device?.type;
                if (deviceType == "tablet") {
                    return Platform.iPad;
                }
                return Platform.iPhone;
            }
            case "Mac OS": {
                if (isTouchDevice()) {
                    return Platform.iPad;
                }
                return Platform.Mac;
            }
            case "Windows": {
                return Platform.Windows;
            }
            case "Android": {
                return Platform.Android;
            }
            case "Linux": {
                return Platform.Linux;
            }
            default:
                return Platform.Other;
        }
    }
    //Can be used for live decision making in the code (eg.: show ipad download button on ipad)
    getPlatform() {
        return this.platform;
    }
    isShaprSupportedPlatform() {
        return (this.platform === Platform.Mac ||
            this.platform === Platform.Windows ||
            this.platform === Platform.iPad);
    }
    //Used for analytics
    getOSName() {
        return this.userAgentData?.os?.name;
    }
    //Used for analytics
    getOSVersion() {
        return this.userAgentData?.os?.version;
    }
    //Used for analytics
    getBrowserName() {
        return this.userAgentData?.browser?.name;
    }
    //Used for analytics
    getBrowserVersion() {
        return this.userAgentData?.browser?.version;
    }
}

export { Platform, PlatformAPI, isTouchDevice };
//# sourceMappingURL=platform.js.map
